import { render, staticRenderFns } from "./text-pillars3.vue?vue&type=template&id=3a4287e4&scoped=true&"
var script = {}
import style0 from "./text-pillars3.vue?vue&type=style&index=0&id=3a4287e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4287e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a4287e4')) {
      api.createRecord('3a4287e4', component.options)
    } else {
      api.reload('3a4287e4', component.options)
    }
    module.hot.accept("./text-pillars3.vue?vue&type=template&id=3a4287e4&scoped=true&", function () {
      api.rerender('3a4287e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/cssfx/components/text-pillars3.vue"
export default component.exports